import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { SnLayer } from 'libs/api/entities/src/lib/layer';
import { SnLayersAPI } from 'libs/api/services/src/lib/layers.service';
import { ISnListQueryParameters } from 'libs/api/src/lib/interfaces/list-query-parameters.interface';
import { ISnListResponse } from 'libs/api/src/lib/interfaces/list-response.interface';
import { SnDataListComponent } from 'libs/ui/data-list/src/lib/components';

@Component({
  selector: 'sn-layers-search-dialog',
  templateUrl: './layers-search-dialog.component.html',
  styleUrls: ['./layers-search-dialog.component.scss'],
})
export class LayersSearchDialogComponent implements OnDestroy, OnInit {
  @ViewChild('list', { static: false })
  public readonly list: SnDataListComponent<SnLayer>;
  public readonly loadData = this._loadData.bind(this);
  public readonly columns: string[] = ['select', 'name'];
  public selection = new SelectionModel<SnLayer>(true, []);
  public selected;

  private _querySearch: string;
  private readonly _destroy$ = new Subject();

  constructor(
    private readonly _dialogRef: MatDialogRef<LayersSearchDialogComponent>,
    private readonly _layersApi: SnLayersAPI,
  ) {}

  public ngOnInit(): void {}

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public onSearchValueChange(value: string): void {
    this._querySearch = value;
    this._reloadData();
  }

  public submitForm(): void {
    this._reloadData();
  }

  public onSelected(layer: any): void {
    this._dialogRef.close(layer);
  }

  public cancel(): void {
    this._dialogRef.close();
  }

  public isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    const numRows = this.list.dataSource.data.length;
    return numSelected === numRows;
  }

  public saveLayers(): void {
    const layers = this.selection.selected.map((layer) => layer);
    this.onSelected(layers);
  }

  public masterToggle(): void {
    this.isAllSelected()
      ? this.selection.clear()
      : this.list.dataSource.data.forEach((row) => this.selection.select(row));
  }

  private _reloadData(): void {
    this.list.reference.reload();
  }

  private _loadData(params?: ISnListQueryParameters): Observable<ISnListResponse<SnLayer>> {
    if (this._querySearch) {
      params.search = this._querySearch;
    }
    return this._layersApi
      .getLayerList(this._prepareQueryParams(params))
      .pipe(takeUntil(this._destroy$));
  }

  private _prepareQueryParams(params: any): any {
    return {
      ...params,
      ordering: {
        active: 'name',
        direction: 'asc',
      },
      page: params.page,
      pageSize: 'all',
    };
  }
}
